<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="skipped-page">
    <div class="page-header">
      <button class="back-btn" @click="goBack" title="Wstecz">
        <v-icon size="18">mdi-arrow-left</v-icon>
      </button>
      <div class="page-header-text">
        <h1 class="page-title">Pominięte importy</h1>
      </div>
    </div>
    <v-card outlined class="rounded-lg" style="overflow: hidden;">
    <v-data-table
      :headers="headers"
      :items="skippedRecords"
      :loading="loading"
      :items-per-page="25"
      :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
      class="elevation-0"
    >
      <template v-slot:item.calculated="{ item }">
        {{ item.calculated != null ? (item.calculated / 100).toFixed(2) : '-' }}
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:item.importRawData="{ item }">
        <div style="max-width: 300px;">
          <div class="d-flex align-center">
            <span class="text-caption text-truncate" style="max-width: 240px;">{{ truncate(item.importRawData, 80) }}</span>
            <v-btn x-small icon @click="toggleRawData(item.id)">
              <v-icon small>{{ expandedRawData[item.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </div>
          <div v-if="expandedRawData[item.id]" class="mt-1">
            <pre class="text-caption pa-2" style="background: #f5f5f5; color: #333; border-radius: 4px; max-height: 300px; overflow: auto; white-space: pre-wrap; word-break: break-all;">{{ formatRawData(item.importRawData) }}</pre>
          </div>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn x-small color="primary" @click="openAssignDialog(item)">
          {{ $t('skippedImport.assign') }}
        </v-btn>
      </template>
    </v-data-table>

    <!-- Assign Driver Dialog -->
    <v-dialog v-model="assignDialog" max-width="500">
      <v-card>
        <v-card-title>
          {{ $t('skippedImport.assign') }} {{ assignItem ? assignItem.type : '' }} ID: {{ assignItem ? assignItem.recordId : '' }}
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedDriver"
            :items="drivers"
            :loading="driversLoading"
            :search-input.sync="driverSearch"
            item-text="label"
            item-value="id"
            :label="$t('skippedImport.selectDriver')"
            :placeholder="$t('skippedImport.searchDriver')"
            outlined
            dense
            no-filter
            :no-data-text="$t('skippedImport.noDriversFound')"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="assignDialog = false">{{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" :disabled="!selectedDriver" @click="assignDriver()">
            {{ $t('skippedImport.assign') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import * as dayjs from "dayjs";

export default {
  name: "SkippedImportPage",
  data: () => ({
    loading: false,
    skippedRecords: [],
    headers: [
      { text: "ID rekordu", value: "recordId", sortable: true },
      { text: "Typ", value: "type", sortable: true },
      { text: "Kwota", value: "calculated", sortable: true },
      { text: "Data importu", value: "createdAt", sortable: true },
      { text: "Akcje", value: "actions", sortable: false },
      { text: "Surowe dane", value: "importRawData", sortable: false, width: "300px" },
    ],
    assignDialog: false,
    assignItem: null,
    selectedDriver: null,
    drivers: [],
    driversLoading: false,
    driverSearch: "",
    expandedRawData: {},
  }),
  watch: {
    driverSearch(val) {
      if (val && val.length >= 2) {
        this.fetchDrivers(val);
      } else if (!val || val.length === 0) {
        this.fetchDrivers("");
      }
    },
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      const importId = this.$route.query.id;
      if (!importId) {
        Swal.fire("Błąd", "Brak ID importu", "error");
        return;
      }
      this.loading = true;
      try {
        const response = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "import/skipped/" + importId,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.skippedRecords = response.data.data;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response?.data?.message?.toString() || "Wystąpił błąd", "error");
      }
      this.loading = false;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD HH:mm");
    },
    truncate(str, maxLen) {
      if (!str) return '-';
      return str.length > maxLen ? str.substring(0, maxLen) + '...' : str;
    },
    toggleRawData(id) {
      this.$set(this.expandedRawData, id, !this.expandedRawData[id]);
    },
    formatRawData(raw) {
      if (!raw) return '-';
      try {
        return JSON.stringify(JSON.parse(raw), null, 2);
      } catch {
        return raw;
      }
    },
    goBack() {
      this.$router.push('/import-history');
    },
    openAssignDialog(item) {
      this.assignItem = item;
      this.selectedDriver = null;
      this.driverSearch = "";
      this.drivers = [];
      this.assignDialog = true;
      this.fetchDrivers("");
    },
    async fetchDrivers(search) {
      this.driversLoading = true;
      try {
        const response = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `drivers?take=50&skip=1&search=${search || ""}${this.assignItem?.type ? "&missingAppId=" + this.assignItem.type : ""}${this.assignItem?.recordId ? "&recordId=" + encodeURIComponent(this.assignItem.recordId) : ""}`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.drivers = response.data.data.result.map((d) => ({
          id: d.id,
          label: d.firstName + " " + d.lastName + (d.boltId ? " (Bolt: " + d.boltId + ")" : "") + (d.uberId ? " (Uber: " + d.uberId + ")" : "") + (d.freeNowId ? " (FreeNow: " + d.freeNowId + ")" : ""),
        }));
      } catch (e) {
        console.log(e);
      }
      this.driversLoading = false;
    },
    async assignDriver() {
      if (!this.selectedDriver || !this.assignItem) return;
      try {
        const res = await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "import/assign-driver",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: {
            importDataId: this.assignItem.id,
            driverId: this.selectedDriver,
          },
        });
        this.assignDialog = false;
        const count = res.data?.data?.assignedCount || 1;
        Swal.fire(
          "Sukces",
          count > 1
            ? `Przypisano kierowcę i jego ${count} pominiętych rozliczeń tego ID (ze wszystkich importów).`
            : "Przypisano kierowcę.",
          "success",
        );
        await this.initialize();
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response?.data?.message?.toString() || "Wystąpił błąd", "error");
      }
    },
  },
};
</script>

<style scoped>
.skipped-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { display: flex; align-items: center; gap: 12px; padding: 4px 4px 18px; }
.back-btn { width: 40px; height: 40px; border-radius: 12px; background: #232838; border: 1px solid rgba(255,255,255,0.06); color: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.back-btn:hover { background: #2A3042; }
.back-btn .v-icon { color: inherit !important; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }

.skipped-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.skipped-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; }
.skipped-page >>> .v-data-table { background: transparent !important; color: #fff !important; }
.skipped-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.skipped-page >>> .v-data-table tbody tr { background: transparent !important; }
.skipped-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.skipped-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.skipped-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.skipped-page >>> .v-btn:not(.v-btn--icon):not(.back-btn) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.skipped-page >>> .v-btn.secondary { background: rgba(255,255,255,0.06) !important; color: #B0BEC5 !important; }
.skipped-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.skipped-page >>> pre { background: #181C28 !important; color: #B0BEC5 !important; border: 1px solid rgba(255,255,255,0.06); }
</style>
